import { PageContentAnimation } from '../../../components/layout/page-content-animation';
import { useTranslation } from 'react-i18next';
import { ExpiringContractWidget, TotalIncomeWidget, OccupancyRateWidget, ContractLengthWidget } from './components/';
import { useRouteDocumentTitle } from '@client/toolkit';
import { WidgetsGrid } from '../../../components';
import { DashboardPaths } from '../dashboard.router';
import { DashboardFilters } from '../components';
import { DateRangePresetKey } from '../components/DashboardFilters/useDefaultDateRangePresets';
import { useDashboardFilters } from '../context/dashboard-filters.context';

const MANAGEMENT_DASHBOARD_PRESETS = [
  DateRangePresetKey.THISMONTH,
  DateRangePresetKey.LASTMONTH,
  DateRangePresetKey.LAST6MONTHS,
  DateRangePresetKey.NEXT6MONTHS,
  DateRangePresetKey.NEXT12MONTHS,
  DateRangePresetKey.THISYEAR,
  DateRangePresetKey.LASTYEAR,
  DateRangePresetKey.NEXTYEAR,
  DateRangePresetKey.CUSTOM,
];

export const DashboardBasicViewRoute = () => {
  const { t: routeT } = useTranslation('dashboard');
  useRouteDocumentTitle(routeT('dashboard.agreements.documentTitle'), DashboardPaths.Dashboard);
  const { selectedSpaceIds, selectedDateFrom, selectedDateTo } = useDashboardFilters();

  return (
    <PageContentAnimation className="flex flex-col gap-8">
      <DashboardFilters
        visiblePresets={MANAGEMENT_DASHBOARD_PRESETS}
        defaultPresetKey={DateRangePresetKey.NEXT12MONTHS}
        showOnlySpacesWithManagementEnabled
      />
      <WidgetsGrid>
        <TotalIncomeWidget
          buildingIds={selectedSpaceIds}
          selectedDateFrom={selectedDateFrom}
          selectedDateTo={selectedDateTo}
        />
        <OccupancyRateWidget
          buildingIds={selectedSpaceIds}
          selectedDateFrom={selectedDateFrom}
          selectedDateTo={selectedDateTo}
        />
        <ContractLengthWidget
          buildingIds={selectedSpaceIds}
          selectedDateFrom={selectedDateFrom}
          selectedDateTo={selectedDateTo}
        />
        <ExpiringContractWidget
          buildingIds={selectedSpaceIds}
          selectedDateFrom={selectedDateFrom}
          selectedDateTo={selectedDateTo}
        />
      </WidgetsGrid>
    </PageContentAnimation>
  );
};
